import store from "@/store/index.js";
import djsApi from "./djsApi.js";
import smCom from "../global/smCom.js";
import timeHelper from "../global/timeHelper.js";

// 获取菜品分类信息 GET_PRO_CLS_INFO
const GET_VEN_CLS_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper; //【ALL、BIG_CLS、SUB_CLS、CLS_ID】
  js['DSP_CA'] = obj.dsp_ca || 'WIN'; // 显示客户端程序 SIM简易列表 APPLET小程序端 WIN电脑端

  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["DSP_LVL"] = obj.dsp_lvl || "ALL";
  js["CLS_ID"] = obj.cls_id || "1001";
  js["CLS_ID_EX"] = obj.cls_id_ex || "1001";
  js["TOP_YN"] = obj.top_yn || "";
  js["STATE_ID"] = obj.state_id || "sipZc"; //【 sipZc（正常） sipFzc（非正常）】
  js["QRY_TXT"] = obj.qry_txt || "";
  js["FZY_YN"] = obj.fzy_yn || 'Y';
  let res = await djsApi.fDjsQueryApi({
    methodName: "GET_VEN_CLS_INFO",
    js
  });
  return res;
};


// 获取菜品分类信息 GET_PRO_CLS_INFO
const GET_PRO_CLS_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper; //【ALL、BIG_CLS、SUB_CLS、CLS_ID】
  js['DSP_CA'] = obj.dsp_ca || 'WIN'; // 显示客户端程序 SIM简易列表 APPLET小程序端 WIN电脑端

  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["DSP_LVL"] = obj.dsp_lvl || "ALL";
  js["CLS_ID"] = obj.cls_id || "1001";
  js["CLS_ID_EX"] = obj.cls_id_ex || "1001";
  js["TOP_YN"] = obj.top_yn || "";
  js["STATE_ID"] = obj.state_id || "sipZc"; //【 sipZc（正常） sipFzc（非正常）】
  js["QRY_TXT"] = obj.qry_txt || "";
  js["FZY_YN"] = obj.fzy_yn || 'Y';
  let res = await djsApi.fDjsQueryApi({
    methodName: "GET_PRO_CLS_INFO",
    js
  });
  return res;
};
// 获取菜品分类信息 GET_PRO_CLS_INFO
const GET_SD_PRO_CLS_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper; //【ALL、BIG_CLS、SUB_CLS、CLS_ID】
  js['DSP_CA'] = obj.dsp_ca || 'WIN'; // 显示客户端程序 SIM简易列表 APPLET小程序端 WIN电脑端

  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["DSP_LVL"] = obj.dsp_lvl || "ALL";
  js["CLS_ID"] = obj.cls_id || "1001";
  js["CLS_ID_EX"] = obj.cls_id_ex || "1001";
  js["STATE_ID"] = obj.state_id || "sipZc"; //【 sipZc（正常） sipFzc（非正常）】
  js["QRY_TXT"] = obj.qry_txt || "";
  js["FZY_YN"] = obj.fzy_yn || 'Y';
  let res = await djsApi.fDjsQueryApi({
    methodName: "GET_SD_PRO_CLS_INFO",
    js
  });
  return res;
};
// 获取门店菜品列表 GET_MALL_PRO_INFO
const GET_MALL_PRO_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper; //【PRO_LIST】
  js['DSP_CA'] = obj.dsp_ca || 'WIN'; // 显示客户端程序 SIM简易列表 APPLET小程序端 WIN电脑端
  js["SAAS_VER_ID"] = obj.saas_ver_id || (store.state.djsAdmin.saas_type_id == 'sipLs' ? 'sipDjsxls' : 'sipDjsxcy');


  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["CLS_ID_EX"] = obj.cls_id_ex || "1001";
  js["PRO_ID"] = obj.pro_id;
  js["STATE_ID"] = obj.state_id || "sipAll"; //【sipAll（全部）、sipZs（在售）、sipTs（停售）、sipSc（删除）】
  js["TYPE_ID"] = obj.type_id || "sipAll"; //

  js["VEN_ID"] = obj.ven_id || ""; // 供应商编码
  js["BRAND_ID"] = obj.brand_id || ""; // 品牌编码
  js["PRO_ADR"] = obj.pro_adr || ""; // 地址
  js["PRICE_WAY_ID"] = obj.price_way_id || ""; //
  js["BUS_TYPE_ID"] = obj.bus_type_id || ""; //
  js["STOCK_WAY_ID"] = obj.stock_way_id || ""; //
  js["IMG_TYPE_ID"] = obj.img_type_id || ""; //
  js["IN_PRICE_YN_ID"] = obj.in_price_yn_id || "sipN"; //
  js["SALE_PRICE_YN_ID"] = obj.sale_price_yn_id || "sipN"; //
  js["VIP_PRICE_YN_ID"] = obj.vip_price_yn_id || "sipN"; //
  js["WS_PRICE_YN_ID"] = obj.ws_price_yn_id || "sipN"; //
  js["DV_PRICE_YN_ID"] = obj.dv_price_yn_id || "sipN"; //
  js["HIT_YN"] = obj.hit_yn || ""; //


  js["QRY_TXT"] = obj.qry_txt;
  js["FZY_YN"] = obj.fzy_yn || 'Y';
  js["PAGE_SIZE"] = obj.page_size;
  js["NOW_PAGE"] = obj.now_page;
  js["ORDER_BY"] = obj.order_by;
  let res = await djsApi.fDjsQueryApi({
    methodName: "GET_MALL_PRO_INFO",
    js
  });
  return res;
};
const GET_SD_MALL_PRO_INFO = async (obj) => {

  let js = {
    OPER: 'PRO_LIST', // 操作 PRO_LIST     PRO_ID
    DSP_CA: 'SIM', // 显示客户端程序  SIM 简易  
    MALL_ID: obj.mall_id || store.state.djsAdmin.mall_id, // 门店编码
    CLS_ID_EX: obj.cls_id_ex || '1001', // 扫码点单分类编码
    // PRO_ID: string, // 菜品编码
    QRY_TXT: obj.qry_txt, // 搜索内容
    FZY_YN: obj.fzy_yn, // 是否模糊搜索
    PAGE_SIZE: obj.page_size, // 每页记录数 默认 50
    NOW_PAGE: obj.now_page, // 当前页码
  }
  let res = await djsApi.fDjsQueryApi({
    methodName: "GET_SD_MALL_PRO_INFO",
    js
  });
  return res;
};

// 获取门店菜品规格详情 GET_MALL_PRO_SPEC_INFO
const GET_MALL_PRO_SPEC_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper || ""; //【SPEC_LIST】
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["SAAS_VER_ID"] = obj.saas_ver_id || (store.state.djsAdmin.saas_type_id == 'sipLs' ? 'sipDjsxls' : 'sipDjsxcy');
  js['DSP_CA'] = obj.dsp_ca || 'WIN'; // 显示客户端程序 SIM简易列表 APPLET小程序端 WIN电脑端
  js["PRO_ID"] = obj.pro_id || "";
  js["CLS_ID_EX"] = obj.cls_id_ex || "";
  js["SPEC_ID"] = obj.spec_id || "";
  js["STATE_ID"] = obj.state_id || "sipAll"; //【sipAll（全部）、sipZs（在售）、sipTs（停售）、sipSc（删除）】
  js["QRY_TXT"] = obj.qry_txt || "";
  js["FZY_YN"] = obj.fzy_yn || 'Y';
  js["PAGE_SIZE"] = obj.page_size || 50;
  js["NOW_PAGE"] = obj.now_page || 1;
  js["ORDER_BY"] = obj.order_by || "";

  let res = await djsApi.fDjsQueryApi({
    methodName: "GET_MALL_PRO_SPEC_INFO",
    js
  });
  return res;
};
// 获取加料分类信息  GET_FEED_CLS_INFO
const GET_FEED_CLS_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper || ""; //【SPEC_LIST】
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["CLS_ID"] = obj.cls_id || "1001";
  js["CLS_ID_EX"] = obj.cls_id_ex || "1001";
  js["TOP_YN"] = obj.top_yn || "";
  js["STATE_ID"] = obj.state_id || "sipZc"; //【 sipZc（正常） sipFzc（非正常）】
  js["QRY_TXT"] = obj.qry_txt || "";
  js["DSP_CA"] = obj.dsp_ca || "WIN";
  js["DSP_LVL"] = obj.dsp_lvl || "ALL";
  js["FZY_YN"] = obj.fzy_yn || 'Y';

  let res = await djsApi.fDjsQueryApi({
    methodName: "GET_FEED_CLS_INFO",
    js
  });
  return res;
};
// 获取加料信息 GET_FEED_INFO
const GET_FEED_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper || ""; //【SPEC_LIST】
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["CLS_ID_EX"] = obj.cls_id_ex || "1001";
  js["FEED_ID"] = obj.feed_id || "";
  js["STATE_ID"] = obj.state_id || "sipZc"; //【sipALL（全部）、sipZc（正常）、sipSc（删除）】
  js["QRY_TXT"] = obj.qry_txt || "";
  js["FZY_YN"] = obj.fzy_yn || 'Y';
  js["PAGE_SIZE"] = obj.page_size || 50;
  js["NOW_PAGE"] = obj.now_page || 1;
  js["ORDER_BY"] = obj.order_by || "";

  let res = await djsApi.fDjsQueryApi({
    methodName: "GET_FEED_INFO",
    js
  });
  return res;
};
// 获取加料信息 GET_FEED_INFO
const GET_PRO_FEED_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper || ""; //PRO_FEED_LIST
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["CLS_ID"] = obj.cls_id || "1001";
  js["CLS_ID_EX"] = obj.cls_id_ex || "1001";
  js["PRO_ID"] = obj.pro_id || "";
  js["STATE_ID"] = obj.state_id || "sipZc"; //【sipALL（全部）、sipZc（正常）、sipSc（删除）】
  js["QRY_TXT"] = obj.qry_txt || "";
  js["FZY_YN"] = obj.fzy_yn || 'Y';
  js["PAGE_SIZE"] = obj.page_size || 50;
  js["NOW_PAGE"] = obj.now_page || 1;
  js["ORDER_BY"] = obj.order_by || "";

  let res = await djsApi.fDjsQueryApi({
    methodName: "GET_PRO_FEED_INFO",
    js
  });
  return res;
};

// 获取做法信息  GET_FLAV_CLS_INFO
const GET_FLAV_CLS_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper || ""; //【SPEC_LIST】
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["CLS_ID"] = obj.cls_id || "1001";
  js["CLS_ID_EX"] = obj.cls_id_ex || "1001";
  js["TOP_YN"] = obj.top_yn || "";
  js["DSP_CA"] = obj.dsp_ca || "WIN";
  js["DSP_LVL"] = obj.dsp_lvl || "ALL";
  js["STATE_ID"] = obj.state_id || "sipZc"; //【 sipZc（正常） sipFzc（非正常）】
  js["QRY_TXT"] = obj.qry_txt || "";
  js["FZY_YN"] = obj.fzy_yn || 'Y';

  let res = await djsApi.fDjsQueryApi({
    methodName: "GET_FLAV_CLS_INFO",
    js
  });
  return res;
};

// 获取加料信息 GET_FLAV_INFO
const GET_FLAV_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper || ""; //【FLAV_LIST】
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["CLS_ID_EX"] = obj.cls_id_ex || "1001";
  js["FLAV_ID"] = obj.flav_id || "";
  js["STATE_ID"] = obj.state_id || "sipZc"; //【sipALL（全部）、sipZc（正常）、sipSc（删除）】
  js["QRY_TXT"] = obj.qry_txt || "";
  js["FZY_YN"] = obj.fzy_yn || 'Y';
  js["PAGE_SIZE"] = obj.page_size || 50;
  js["NOW_PAGE"] = obj.now_page || 1;
  js["ORDER_BY"] = obj.order_by || "";

  let res = await djsApi.fDjsQueryApi({
    methodName: "GET_FLAV_INFO",
    js
  });
  return res;
};

// 获取加料信息 GET_PRO_FLAV_INFO
const GET_PRO_FLAV_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper || ""; //PRO_FEED_LIST
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["CLS_ID"] = obj.cls_id || "1001";
  js["CLS_ID_EX"] = obj.cls_id_ex || "1001";
  js["PRO_ID"] = obj.pro_id || "";
  js["FLAV_ID"] = obj.flav_id || "";
  js["STATE_ID"] = obj.state_id || "sipZc"; //【sipALL（全部）、sipZc（正常）、sipSc（删除）】
  js["QRY_TXT"] = obj.qry_txt || "";
  js["FZY_YN"] = obj.fzy_yn || 'Y';
  js["PAGE_SIZE"] = obj.page_size || 50;
  js["NOW_PAGE"] = obj.now_page || 1;
  js["ORDER_BY"] = obj.order_by || "";

  let res = await djsApi.fDjsQueryApi({
    methodName: "GET_PRO_FLAV_INFO",
    js
  });
  return res;
};

// 获取门店分类信息  GET_MALL_CLS_INFO
const GET_MALL_CLS_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper || "";
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["CLS_ID"] = obj.cls_id || "1001";
  js["CLS_ID_EX"] = obj.cls_id_ex || "1001";
  js["TOP_YN"] = obj.top_yn || "";
  js["DSP_CA"] = obj.dsp_ca || "WIN";
  js["DSP_LVL"] = obj.dsp_lvl || "ALL";
  js["STATE_ID"] = obj.state_id || "sipZc"; //【 sipZc（正常） sipFzc（非正常）】
  js["DSP_CA"] = obj.dsp_ca || "WIN";
  js["DSP_LVL"] = obj.dsp_lvl || "ALL";
  js["QRY_TXT"] = obj.qry_txt || "";
  js["FZY_YN"] = obj.fzy_yn || 'Y';

  let res = await djsApi.fDjsQueryApi({
    methodName: "GET_MALL_CLS_INFO",
    js
  });
  return res;
};

// 获取品牌分类信息  GET_BRAND_INFO
const GET_BRAND_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper || "";
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["CLS_ID"] = obj.cls_id || "1001";
  js["CLS_ID_EX"] = obj.cls_id_ex || "1001";
  js["TOP_YN"] = obj.top_yn || "";
  js["DSP_CA"] = obj.dsp_ca || "WIN";
  js["DSP_LVL"] = obj.dsp_lvl || "ALL";
  js["STATE_ID"] = obj.state_id || "sipZc"; //【 sipZc（正常） sipFzc（非正常）】
  js["DSP_CA"] = obj.dsp_ca || "WIN";
  js["DSP_LVL"] = obj.dsp_lvl || "ALL";
  js["QRY_TXT"] = obj.qry_txt || "";
  js["FZY_YN"] = obj.fzy_yn || 'Y';

  let res = await djsApi.fDjsQueryApi({
    methodName: "GET_BRAND_INFO",
    js
  });
  return res;
};



// 获取门店信息 GET_MALL_INFO
const GET_MALL_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper || ""; //
  js['DSP_CA'] = obj.dsp_ca || 'SIM'; // 显示客户端程序 SIM简易列表 APPLET小程序端 WIN电脑端
  js["USER_ID"] = obj.user_id || store.state.djsAdmin.user_id;
  js["MCH_ID"] = obj.mch_id || store.state.djsAdmin.mch_id;
  js["MALL_ID"] = obj.mall_id || '1001';
  js["CLS_ID_EX"] = obj.cls_id_ex || "1001";
  js["USER_MALL_QX_YN"] = obj.user_mall_qx_yn || "Y";
  js["STATE_ID"] = obj.state_id || "sipZc"; //【sipALL（全部）、sipZc（正常）、sipSc（删除）】
  js["QRY_TXT"] = obj.qry_txt || "";
  js["FZY_YN"] = obj.fzy_yn || 'Y';
  js["PAGE_SIZE"] = obj.page_size || 50;
  js["NOW_PAGE"] = obj.now_page || 1;
  js["ORDER_BY"] = obj.order_by || "";
  console.log(js, 'GET_MALL_INFO')

  let res = await djsApi.fDjsQueryApi({
    methodName: "GET_MALL_INFO",
    js,
    signType: obj.signType
  });
  return res;
};
// 获取餐桌区域信息 GET_DTABLE_CLS_INFO
const GET_DTABLE_CLS_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper || "";
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["CLS_ID"] = obj.cls_id || "1001";
  js["CLS_ID_EX"] = obj.cls_id_ex || "1001";
  js["TOP_YN"] = obj.top_yn || "";
  js["DSP_CA"] = obj.dsp_ca || "WIN";
  js["DSP_LVL"] = obj.dsp_lvl || "ALL";
  js["STATE_ID"] = obj.state_id || "sipZc"; //【 sipZc（正常） sipFzc（非正常）】
  js["QRY_TXT"] = obj.qry_txt || "";
  js["FZY_YN"] = obj.fzy_yn || 'Y';

  let res = await djsApi.fDjsQueryApi({
    methodName: "GET_DTABLE_CLS_INFO",
    js
  });
  return res;
};
// 获取餐桌列表 GET_DTABLE_INFO
const GET_DTABLE_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper || ""; //PRO_FEED_LIST
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["CLS_ID_EX"] = obj.cls_id_ex || "1001";
  js["DTABLE_ID"] = obj.dtable_id || "";
  js["STATE_ID"] = obj.state_id || "sipZc"; //【sipALL（全部）、sipZc（正常）、sipSc（删除）】
  js["QRY_TXT"] = obj.qry_txt || "";
  js["FZY_YN"] = obj.fzy_yn || 'Y';
  js["PAGE_SIZE"] = obj.page_size || 50;
  js["NOW_PAGE"] = obj.now_page || 1;
  js["ORDER_BY"] = obj.order_by || "";

  let res = await djsApi.fDjsQueryApi({
    methodName: "GET_DTABLE_INFO",
    js
  });
  return res;
};

//  获取用户分类信息 GET_USER_CLS_INFO
const GET_USER_CLS_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper || "";
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["CLS_ID"] = obj.cls_id || "1001";
  js["CLS_ID_EX"] = obj.cls_id_ex || "1001";
  js["TOP_YN"] = obj.top_yn || "";
  js["DSP_CA"] = obj.dsp_ca || "WIN";
  js["DSP_LVL"] = obj.dsp_lvl || "ALL";
  js["STATE_ID"] = obj.state_id || "sipZc"; //【 sipZc（正常） sipFzc（非正常）】
  js["QRY_TXT"] = obj.qry_txt || "";
  js["FZY_YN"] = obj.fzy_yn || 'Y';

  let res = await djsApi.fDjsQueryApi({
    methodName: "GET_USER_CLS_INFO",
    js
  });
  return res;
};

// 获取员工列表 GET_USER_INFO
const GET_USER_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper || ""; //PRO_FEED_LIST
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["CLS_ID_EX"] = obj.cls_id_ex || "1001";
  js["USER_ID"] = obj.user_id || "";
  js["STATE_ID"] = obj.state_id || "sipZc"; //【sipALL（全部）、sipZc（正常）、sipSc（删除）】
  js["QRY_TXT"] = obj.qry_txt || "";
  js["FZY_YN"] = obj.fzy_yn || 'Y';
  js["PAGE_SIZE"] = obj.page_size || 50;
  js["NOW_PAGE"] = obj.now_page || 1;
  js["ORDER_BY"] = obj.order_by || "";

  let res = await djsApi.fDjsQueryApi({
    methodName: "GET_USER_INFO",
    js
  });
  return res;
};
const GET_MALL_ACCT_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper || ""; //PRO_FEED_LIST
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["ACCT_ID"] = obj.acct_id;
  js["AMT_ACCT_ID"] = obj.amt_acct_id || '';
  js["STATE_ID"] = obj.state_id || "sipZc"; //【sipALL（全部）、sipZc（正常）、sipSc（删除）】
  js["QRY_TXT"] = obj.qry_txt || "";
  js["FZY_YN"] = obj.fzy_yn || 'Y';
  js["PAGE_SIZE"] = obj.page_size || 50;
  js["NOW_PAGE"] = obj.now_page || 1;
  js["ORDER_BY"] = obj.order_by || "";

  let res = await djsApi.fDjsQueryApi({
    methodName: "GET_MALL_ACCT_INFO",
    js
  });
  return res;
};

const GET_MALL_FEE_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper || ""; //PRO_FEED_LIST
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["FEE_ID"] = obj.fee_id || "";
  js["STATE_ID"] = obj.state_id || "sipZc"; //【sipALL（全部）、sipZc（正常）、sipSc（删除）】
  js["QRY_TXT"] = obj.qry_txt || "";
  js["FZY_YN"] = obj.fzy_yn || 'Y';
  js["PAGE_SIZE"] = obj.page_size || 50;
  js["NOW_PAGE"] = obj.now_page || 1;
  js["ORDER_BY"] = obj.order_by || "";

  let res = await djsApi.fDjsQueryApi({
    methodName: "GET_MALL_FEE_INFO",
    js
  });
  return res;
};
const GET_MALL_AMT_ACCT_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper || ""; //PRO_FEED_LIST
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["AMT_ACCT_ID"] = obj.amt_acct_id;
  js["STATE_ID"] = obj.state_id || "sipZc"; //【sipALL（全部）、sipZc（正常）、sipSc（删除）】
  js["QRY_TXT"] = obj.qry_txt || "";
  js["FZY_YN"] = obj.fzy_yn || 'Y';
  js["PAGE_SIZE"] = obj.page_size || 50;
  js["NOW_PAGE"] = obj.now_page || 1;
  js["ORDER_BY"] = obj.order_by || "";

  let res = await djsApi.fDjsQueryApi({
    methodName: "GET_MALL_AMT_ACCT_INFO",
    js
  });
  return res;
};
const GET_REMARK_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper || ""; //PRO_FEED_LIST
  js["REMARK_TYPE_ID"] = obj.remark_type_id;
  js["REMARK"] = obj.remark;
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["REMARK_ID"] = obj.remark_id;
  js["STATE_ID"] = obj.state_id || "sipZc"; //【sipALL（全部）、sipZc（正常）、sipSc（删除）】
  js["QRY_TXT"] = obj.qry_txt || "";
  js["FZY_YN"] = obj.fzy_yn || 'Y';
  js["PAGE_SIZE"] = obj.page_size || 50;
  js["NOW_PAGE"] = obj.now_page || 1;
  js["ORDER_BY"] = obj.order_by || "";

  let res = await djsApi.fDjsQueryApi({
    methodName: "GET_REMARK_INFO",
    js
  });
  return res;
};

const GET_MALL_COMBO_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper || ""; //PRO_FEED_LIST
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["COMBO_ID"] = obj.combo_id || "";

  js["STATE_ID"] = obj.state_id || "sipZc"; //【sipALL（全部）、sipZc（正常）、sipSc（删除）】
  js["QRY_TXT"] = obj.qry_txt || "";
  js["FZY_YN"] = obj.fzy_yn || 'Y';
  js["PAGE_SIZE"] = obj.page_size || 50;
  js["NOW_PAGE"] = obj.now_page || 1;
  js["ORDER_BY"] = obj.order_by || "";

  let res = await djsApi.fDjsQueryApi({
    methodName: "GET_MALL_COMBO_INFO",
    js
  });
  return res;
};



// const GET_VIP_CLS_INFO = async obj => {
//   let js = {};
//   js["OPER"] = obj.oper || "";
//   js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
//   js["CLS_ID"] = obj.cls_id || "1001";
//   js["CLS_ID_EX"] = obj.cls_id_ex || "1001";
//   js["TOP_YN"] = obj.top_yn || "";
//   js["DSP_CA"] = obj.dsp_ca || "WIN";
//   js["DSP_LVL"] = obj.dsp_lvl || "ALL";
//   js["STATE_ID"] = obj.state_id || "sipZc"; //【 sipZc（正常） sipFzc（非正常）】
//   js["QRY_TXT"] = obj.qry_txt || "";
//   js["FZY_YN"] = obj.fzy_yn || 'Y';

//   let res = await djsApi.fDjsQueryApi({
//     methodName: "GET_VIP_CLS_INFO",
//     js
//   });
//   return res;
// };
// 获取会员信息 GET_VIP_INFO
const GET_VIP_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper || "VIP_LIST"; // 操作类型默认设为会员列表查询
  js["DSP_CA"] = obj.dsp_ca || "WIN"; // 操作类型默认设为会员列表查询
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["CLS_ID_EX"] = obj.cls_id_ex || "1001"; // 默认分类编码
  js["VIP_ID"] = obj.vip_id || "";
  js["CRT_START_TIME"] = obj.crt_start_time || "";
  js["CRT_OVER_TIME"] = obj.crt_over_time || "";
  js["LAST_CONS_START_TIME"] = obj.last_cons_start_time || "";
  js["LAST_CONS_OVER_TIME"] = obj.last_cons_over_time || "";
  js["BAL_AMT_START"] = obj.bal_amt_start || "";
  js["BAL_AMT_OVER"] = obj.bal_amt_over || "";
  js["BAL_PTS_START"] = obj.bal_pts_start || "";
  js["BAL_PTS_OVER"] = obj.bal_pts_over || "";
  js["REC_VIP_ID"] = obj.rec_vip_id || "";


  js["XF_AVG_START_MONEY"] = obj.xf_avg_start_money || "";
  js["XF_AVG_OVER_MONEY"] = obj.xf_avg_over_money || "";
  js["YF_NOW_START_MONEY"] = obj.yf_now_start_money || "";
  js["YF_NOW_OVER_MONEY"] = obj.yf_now_over_money || "";
  js["ELABLE_ID"] = obj.elable_id || "";
  js["STATE_ID"] = obj.state_id || "sipAll"; // 默认查询全部状态
  js["QRY_TXT"] = obj.qry_txt || "";

  js["QRY_FIELD"] = obj.qry_field || "";
  js["FZY_YN"] = obj.fzy_yn || 'Y';
  js["HIT_YN"] = obj.hit_yn || "N";
  js["PAGE_SIZE"] = obj.page_size || 50;
  js["NOW_PAGE"] = obj.now_page || 1;
  js["ORDER_BY"] = obj.order_by || "";

  let res = await djsApi.fDjsQueryApi({
    methodName: "GET_VIP_INFO",
    js
  });
  return res;
};

// 查询订单信息 GET_POS_MASTER
const GET_POS_MASTER = async obj => {
  let js = {};
  js["OPER"] = obj.oper; // 操作类型，默认为订单列表查询
  js['DSP_CA'] = obj.dsp_ca || 'WIN'; // 显示客户端程序 SIM简易列表 APPLET小程序端 WIN电脑端

  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id; // 门店编码，默认从 Vuex 获取
  js["TIME_F_TYPE"] = obj.time_f_type || ""; // 时间字段类别，默认为空
  js["START_TIME"] = obj.start_time || ""; // 开始时间，默认为空
  js["OVER_TIME"] = obj.over_time || ""; // 结束时间，默认为空
  js["USER_F_TYPE"] = obj.user_f_type || ""; // 员工字段类别，默认为空
  js["USER_F_VALUE"] = obj.user_f_value || ""; // 员工字段值，默认为空
  js["STR_F_TYPE"] = obj.str_f_type || ""; // 字符串字段类别，默认为空
  js["STR_F_VALUE"] = obj.str_f_value || ""; // 字符串字段值，默认为空
  js["AMT_F_TYPE"] = obj.amt_f_type || ""; // 金额字段类别，默认为空
  js["AMT_START_VALUE"] = obj.amt_start_value || ""; // 起始金额字段值，默认为空
  js["AMT_OVER_VALUE"] = obj.amt_over_value || ""; // 结束金额字段值，默认为空
  js["BUS_TYPE_ID"] = obj.bus_type_id || ""; // 订单类型，默认为空
  js["STATE_ID"] = obj.state_id || "sipAll"; // 订单状态，默认为全部
  js["PAY_ACCT_ID"] = obj.pay_acct_id || ""; // 支付方式，默认为空
  js["DINER_START_NUM"] = obj.diner_start_num || ""; // 起始就餐人数，默认为空
  js["DINER_OVER_NUM"] = obj.diner_over_num || ""; // 结束就餐人数，默认为空
  js["DTABLE_CLS_ID_EX"] = obj.dtable_cls_id_ex || ""; // 桌台区域id，默认为空
  js["DTABLE_ID"] = obj.dtable_id || ""; // 桌台号，默认为空
  js["SEN_OPER_ID"] = obj.sen_oper_id || ""; // 敏感操作，默认为空
  js["CHG_FROM"] = obj.chg_from || ""; // 订单来源，默认为空
  js["REMARK"] = obj.remark || ""; // 订单备注，默认为空
  js["QRY_TXT"] = obj.qry_txt || ""; // 搜索内容，默认为空
  js["FZY_YN"] = obj.fzy_yn; // 是否模糊搜索，默认为否
  js["DSP_CA"] = obj.dsp_ca || "WIN";
  js["HIT_YN"] = obj.hit_yn || "N";
  js["ORD_ATTR"] = obj.ord_attr || ""; // 订单属性，默认为空

  js["PAGE_SIZE"] = obj.page_size || 50; // 每页记录数，默认为 50
  js["NOW_PAGE"] = obj.now_page || 1; // 当前页码，默认为第一页

  js["REQ_ID"] = obj.req_id || "";
  js["ORD_ID"] = obj.ord_id || "";

  let res = await djsApi.fDjsQueryApi({
    methodName: "GET_POS_MASTER",
    js
  });
  return res;
};

// 获取菜品汇总信息 GET_POS_PRO_TOTAL
const GET_POS_PRO_TOTAL = async obj => {
  let js = {};
  js["DSP_CA"] = obj.dsp_ca || "WIN";
  js["HIT_YN"] = obj.hit_yn || "N";
  // 基础参数
  js["OPER"] = obj.oper || "PRO_LIST";
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;

  // 时间参数
  js["TIME_F_TYPE"] = obj.time_f_type || "";
  js["START_TIME"] = obj.start_time || "";
  js["OVER_TIME"] = obj.over_time || "";

  // 菜品参数
  js["PRO_F_TYPE"] = obj.pro_f_type || "";
  js["PRO_F_VALUE"] = obj.pro_f_value || "";

  // 员工参数
  js["USER_F_TYPE"] = obj.user_f_type || "";
  js["USER_F_VALUE"] = obj.user_f_value || "";

  // 字符串参数
  js["STR_F_TYPE"] = obj.str_f_type || "";
  js["STR_F_VALUE"] = obj.str_f_value || "";

  // 业务参数
  js["BUS_TYPE_ID"] = obj.bus_type_id || "";
  js["STATE_ID"] = obj.state_id || "sipAll";
  js["PRO_CLS_ID"] = obj.pro_cls_id || "";
  js["PRO_TYPE"] = obj.pro_type || "";
  js["SALE_TYPE"] = obj.sale_type || "";
  js["DTABLE_CLS_ID_EX"] = obj.dtable_cls_id_ex || "";
  js["DTABLE_ID"] = obj.dtable_id || "";
  js["CHG_FROM"] = obj.chg_from || "";
  js["REMARK"] = obj.remark || "";

  // 搜索参数
  js["QRY_TXT"] = obj.qry_txt || "";
  js["FZY_YN"] = obj.fzy_yn;

  // 分页参数
  js["PAGE_SIZE"] = obj.page_size || 50;
  js["NOW_PAGE"] = obj.now_page || 1;

  let res = await djsApi.fDjsQueryApi({
    methodName: "GET_POS_PRO_TOTAL",
    js
  });
  return res;
};

// 获取新数据（请根据实际功能命名）
const GET_POS_PRO_DETAIL = async obj => {
  let js = {};
  js["OPER"] = obj.oper || "PRO_LIST"; // 操作类型
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id; // 门店编码
  js["DSP_CA"] = obj.dsp_ca || "WIN";
  js["HIT_YN"] = obj.hit_yn || "N";
  js["TIME_F_TYPE"] = obj.time_f_type || ""; // 时间字段类别
  js["START_TIME"] = obj.start_time || ""; // 开始时间
  js["OVER_TIME"] = obj.over_time || ""; // 结束时间
  js["PRO_F_TYPE"] = obj.pro_f_type || ""; // 菜品字段类别
  js["PRO_F_VALUE"] = obj.pro_f_value || ""; // 菜品字段值
  js["USER_F_TYPE"] = obj.user_f_type || ""; // 员工字段类别
  js["USER_F_VALUE"] = obj.user_f_value || ""; // 员工字段值
  js["STR_F_TYPE"] = obj.str_f_type || ""; // 字符串字段类别
  js["STR_F_VALUE"] = obj.str_f_value || ""; // 字符串字段值
  js["BUS_TYPE_ID"] = obj.bus_type_id || ""; // 订单类型
  js["STATE_ID"] = obj.state_id || "sipAll"; // 订单状态
  js["PRO_CLS_ID"] = obj.pro_cls_id || ""; // 菜品分类id
  js["PRO_TYPE"] = obj.pro_type || ""; // 菜品类型
  js["SALE_TYPE"] = obj.sale_type || ""; // 菜品标签
  js["DTABLE_CLS_ID"] = obj.dtable_cls_id || ""; // 桌台区域id
  js["DTABLE_ID"] = obj.dtable_id || ""; // 桌台号
  js["CHG_FROM"] = obj.chg_from || ""; // 订单来源
  js["REMARK"] = obj.remark || ""; // 订单备注
  js["QRY_TXT"] = obj.qry_txt || ""; // 搜索内容
  js["FZY_YN"] = obj.fzy_yn; // 是否模糊搜索
  js["PAGE_SIZE"] = obj.page_size || 50; // 每页记录数
  js["NOW_PAGE"] = obj.now_page || 1; // 当前页码

  let res = await djsApi.fDjsQueryApi({
    methodName: "GET_POS_PRO_DETAIL", // 请替换为实际接口名称
    js
  });
  return res;
};


const GET_MCH_LNK_ACCT_INFO = async (obj) => {
  let js = {};
  js["OPER"] = obj.oper || ""; // 操作
  js["DSP_CA"] = obj.dsp_ca || "SIM"; // 显示客户端程序 APPLET小程序端 WIN电脑端 SIM 简易数据
  js["MCH_ID"] = obj.mch_id || store.state.djsAdmin.mch_id; // 门店编码
  js["QRY_TXT"] = obj.qry_txt || ""; // 搜索内容
  js["FZY_YN"] = obj.fzy_yn || 'Y'; // 是否模糊搜索
  js["PAGE_SIZE"] = obj.page_size || 50; // 每页记录数 默认 50
  js["NOW_PAGE"] = obj.now_page || 1; // 当前页码
  js["ORDER_BY"] = obj.order_by || ""; // 排序
  js["EXP_DAY"] = obj.exp_day || ''; // 查询将过期门店 默认30天
  js["TAG_ID"] = obj.tag_id || ''; // 标签id 如sipZdkh 重点客户
  js["SAAS_TYPE_ID"] = obj.saas_type_id || ''; // saas软件类型  零售sipLs  餐饮sipCy
  js["SAAS_VER_ID"] = obj.saas_ver_id || ''; // saas版本 尚米零售v8  sipLsv8 尚米餐饮v8 sipCyv8
  js["MALL_TYPE_ID"] = obj.mall_type_id || ''; // 门店类型id sipMls 连锁  sipMdd 单店 sipMjm加盟
  js["MALL_VER_ID"] = obj.mall_ver_id || ''; // 门店版本id sipBzb标准版  sipPjb普及版 sipQjb旗舰版
  console.log(js);
  let res = await djsApi.fDjsQueryApi({
    methodName: 'GET_MCH_LNK_ACCT_INFO',
    js
  });
  console.log(res);
  return res;
}


// 获取SAAS商户员工绑定信息
const GET_SAAS_MCH_USER_BAND_INFO = async obj => {
  let js = {};
  js['OPER'] = obj.oper || ''; // 操作
  js['DSP_CA'] = 'SIM'; // 显示客户端程序 SIM简易列表 APPLET小程序端 WIN电脑端
  js['BAND_TYPE'] = 'PHONE'; // 绑定类型 手机号 PHONE 公众号WECHAT_OPEN_ID 小程序WMIN_APPID
  js['ACCT_ID'] = obj.acct_id; // 绑定号码 如手机号 openId

  js["QRY_TXT"] = obj.qry_txt || ""; // 搜索内容
  js["FZY_YN"] = obj.fzy_yn || 'Y'; // 是否模糊搜索
  js["PAGE_SIZE"] = obj.page_size || 50; // 每页记录数 默认 50
  js["NOW_PAGE"] = obj.now_page || 1; // 当前页码

  let res = await djsApi.fSmCloudQueryApi({
    methodName: 'GET_SAAS_MCH_USER_BAND_INFO',
    js,
    mchId: '320250710',
    userId: '320250710',
    signType: 'MD5',
    sOrgAk: 'tucy6kfCCANmOKVvi2K3KsovLeN3klACkgUY4lSb0bHSYxgUoQhZ2wPhysjKfKYf',
    sOrgSk: "Hewuyrmli9JGRu9RLxOUMEcnKXK4xEyV4A5EYRSimxmw8Y06qYSvvKcNgzaKlJJk"
  })
  return res;
}

const GET_AUTO_CODE_LIB = async (obj) => {
  let js = {}
  js['OPER'] = obj.oper
  js['CHG_USER_ID'] = store.state.djsAdmin.user_id
  js['MALL_ID'] = store.state.djsAdmin.mall_id
  js['AUTO_RULE'] = obj.auto_rule || 'pre'
  js['EX_ID'] = obj.ex_id || ''
  let res = await djsApi.fDjsQueryApi({
    methodName: "GET_AUTO_CODE_LIB",
    js
  });
  return res;
};
const GET_VIP_CLS_INFO = async (obj) => {
  let js = {}
  js['OPER'] = obj.oper || ''; // 操作 CLS_LIST 、CLS_ID
  js['DSP_CA'] = obj.dsp_ca || 'SIM'; // 显示客户端程序 APPLET小程序端 WIN电脑端 SIM 简易
  js['MALL_ID'] = obj.mall_id || store.state.djsAdmin.mall_id; // 门店编码
  js['CLS_ID'] = obj.cls_id || ''; // 会员等级编码
  js["CLS_ID_EX"] = obj.cls_id_ex || "1001"; // 默认分类编码
  js["TOP_YN"] = obj.top_yn || "";

  js['AUTO_UPDOWNGRADE_YN_ID'] = obj.auto_upgrade_yn_id || ''; // 自动升降级id：sipAll, sipQy,sipJy
  js['STATE_ID'] = obj.state_id || ''; // 状态id：sipAll, sipQy,sipJy
  js['QRY_TXT'] = obj.qry_txt || ''; // 搜索内容：会员等级名称、拼音码
  js['FZY_YN'] = obj.fzy_yn || 'Y'; // 是否模糊搜索
  js['PAGE_SIZE'] = obj.page_size || 50; // 每页记录数 默认 50
  js['NOW_PAGE'] = obj.now_page || 1; // 当前页码
  let res = await djsApi.fDjsQueryApi({
    methodName: "GET_VIP_CLS_INFO",
    js
  });
  return res;
};
const GET_VIP_RCHG_RULE = async (obj) => {
  let js = {}
  js['OPER'] = obj.oper || ''; // 操作   RULE_LIST     RULE_ID 
  js['DSP_CA'] = obj.dsp_ca || 'SIM'; // 显示客户端程序 APPLET小程序端 WIN电脑端 SIM 简易
  js['MALL_ID'] = obj.mall_id || store.state.djsAdmin.mall_id; // 门店编码
  js['RULE_ID'] = obj.rule_id || ''; // 充值方案id
  js['STATE_ID'] = obj.state_id || ''; // 状态id
  js['QRY_TXT'] = obj.qry_txt || ''; // 搜索内容
  js['FZY_YN'] = obj.fzy_yn || 'Y'; // 是否模糊搜索
  js['PAGE_SIZE'] = obj.page_size || 50; // 每页记录数 默认 50
  js['NOW_PAGE'] = obj.now_page || 1; // 当前页码
  js['ORDER_BY'] = obj.order_by || ''; // 排序
  let res = await djsApi.fDjsQueryApi({
    methodName: "GET_VIP_RCHG_RULE",
    js
  });
  return res;
}
const GET_BASE_INFO = async (obj) => {
  let js = {}
  js['OPER'] = obj.oper || ''; // 操作
  js['CLS_ID_EX'] = obj.cls_id_ex; // 
  js['DSP_CA'] = obj.dsp_ca || 'SIM'; // 显示客户端程序
  js['KEY_ID'] = obj.key_id || ''; // 搜索键id
  js['MALL_ID'] = obj.mall_id || store.state.djsAdmin.mall_id; // 门店编码
  js['QRY_TXT'] = obj.qry_txt || ''; // 搜索内容
  js['STATE_ID'] = obj.state_id || 'sipAll'; // 状态id
  js['FZY_YN'] = obj.fzy_yn || 'Y'; // 是否模糊搜索
  js['PAGE_SIZE'] = obj.page_size || 50; // 每页记录数 默认 50
  js['NOW_PAGE'] = obj.now_page || 1; // 当前页码

  let res = await djsApi.fDjsQueryApi({
    methodName: "GET_BASE_INFO",
    js
  });
  return res;
}

export default {
  GET_PRO_CLS_INFO, //获取菜品分类信息
  GET_MALL_PRO_INFO, //获取门店菜品列表
  GET_MALL_PRO_SPEC_INFO, //获取门店菜品规格详情
  GET_FEED_INFO, //获取加料信息
  GET_FEED_CLS_INFO, //获取加料分类信息
  GET_PRO_FEED_INFO, //获取菜品加料信息
  GET_FLAV_CLS_INFO, //获取做法分类信息
  GET_FLAV_INFO, //获取做法信息
  GET_PRO_FLAV_INFO, //获取菜品做法信息
  GET_MALL_CLS_INFO, //获取门店分类信息
  GET_MALL_INFO, //获取门店信息
  GET_SD_MALL_PRO_INFO,
  GET_DTABLE_CLS_INFO, //获取餐桌区域信息
  GET_DTABLE_INFO, //获取餐桌列表
  GET_USER_CLS_INFO, //获取用户分类信息
  GET_USER_INFO, //获取员工列表
  GET_REMARK_INFO, //获取备注信息
  GET_MALL_ACCT_INFO, //获取门店账户信息
  GET_MALL_COMBO_INFO, //获取门店套餐信息
  GET_AUTO_CODE_LIB, //获取自动编码信息
  GET_VIP_CLS_INFO, //获取会员等级信息
  GET_VIP_INFO,
  GET_POS_MASTER, // 查询订单信息
  GET_POS_PRO_TOTAL,
  GET_POS_PRO_DETAIL,
  GET_MCH_LNK_ACCT_INFO,
  GET_SAAS_MCH_USER_BAND_INFO,
  GET_VIP_RCHG_RULE,
  GET_SD_PRO_CLS_INFO,
  GET_BASE_INFO,
  GET_VEN_CLS_INFO, //获取供应商分类信息
  GET_MALL_AMT_ACCT_INFO,
  GET_MALL_FEE_INFO,
  GET_BRAND_INFO, //获取品牌信息
};



//////////////////
// WEBPACK FOOTER
// ./common/api/queryApi.js
// module id = null
// module chunks = 